{
  "blocks": [
    {
      "id": "proc-endometrial-preparation",
      "kind": "procedure",
      "tags": ["fet", "her", "during-cycle"],
      "title": "Endometrial Preparation",
      "subtitle": "Building up the uterine lining to optimal thickness for embryo transfer",
      "body": {
        "procedureName": "Endometrial Preparation",
        "category": "stimulation",
        "description": "Building up the uterine lining to optimal thickness for embryo transfer, using estrogen and progesterone.",
        "howItWorks": "Estrogen is taken (pills, patches, or both) starting early in the cycle to thicken the uterine lining. Monitoring ultrasounds check lining thickness and pattern (target: trilaminar, 7-8mm+). Once adequate, progesterone is added to convert the lining from proliferative to secretory phase, creating the implantation window. Transfer timing is precisely calculated based on when progesterone was started.",
        "duration": "2-4 weeks",
        "whatToExpect": [
          "Daily estrogen medication (oral, vaginal, or patches)",
          "2-3 monitoring ultrasounds over 2 weeks",
          "Possible mild bloating or breast tenderness from estrogen",
          "Addition of progesterone 5 days before transfer",
          "Progesterone can cause fatigue and bloating"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Préparation endométriale",
          "description": "Préparation de la muqueuse utérine jusqu'à l'épaisseur optimale pour le transfert d'embryon, à l'aide d'œstrogènes et de progestérone.",
          "howItWorks": "Les œstrogènes (comprimés, patchs ou les deux) sont introduits en début de cycle pour épaissir la muqueuse utérine. Des échographies de monitorage vérifient l'épaisseur et l'aspect (cible : trilaminaire, ≥ 7-8 mm). Lorsque la muqueuse est adéquate, la progestérone est ajoutée pour faire passer l'endomètre de la phase proliférative à la phase sécrétoire, ouvrant la fenêtre d'implantation. Le moment du transfert est calculé précisément à partir du début de la progestérone.",
          "duration": "2 à 4 semaines",
          "whatToExpect": [
            "Œstrogènes quotidiens (par voie orale, vaginale ou en patchs)",
            "2 à 3 échographies de monitorage sur 2 semaines",
            "Ballonnements légers ou sensibilité des seins possibles avec les œstrogènes",
            "Ajout de la progestérone 5 jours avant le transfert",
            "La progestérone peut entraîner fatigue et ballonnements"
          ]
        }
      },
      "sources": [
        {
          "title": "ESHRE guideline: ovarian stimulation for IVF/ICSI",
          "authors": "ESHRE Guideline Group on Ovarian Stimulation",
          "journal": "Human Reproduction Open",
          "year": 2020,
          "url": "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Luteal phase support for assisted reproduction cycles",
          "authors": "van der Linden M, Buckingham K, Farquhar C, Kremer JAM, Metwally M",
          "journal": "Cochrane Database of Systematic Reviews",
          "year": 2015,
          "url": "https://pubmed.ncbi.nlm.nih.gov/26148507/",
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
